import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";
import {getSessionValue} from "../../Common/Appcommon";

class Reports extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"Reports"} formname={"table_15"} customClass={"field-customization-container reportpadding"} />
        );
    }
}

export default Reports;
